import { render, staticRenderFns } from "./BtnAtualizarResponsavel.vue?vue&type=template&id=1e74034a&"
import script from "./BtnAtualizarResponsavel.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarResponsavel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports